import { registerPlugin } from '@capacitor/core';

interface IAddPassOptions {
  encodedPass: string;
}

export interface IApplePassPlugin extends Plugin {
  canAddPasses: () => boolean;
  addPass: (options: IAddPassOptions) => void;
}

export const ApplePassPlugin = registerPlugin<IApplePassPlugin>('ApplePassPlugin');
